import { ReactNode } from 'react';
import { Box, Stack } from '@rossum/ui/material';

type TabPanelProps = {
  children?: ReactNode;
  active: boolean;
  tabId: string;
};

export const TabPanel = (props: TabPanelProps) => {
  const { children, active, tabId } = props;

  return (
    <Stack role="tabpanel" hidden={!active} id={tabId}>
      {active && <Box>{children}</Box>}
    </Stack>
  );
};
